import { render, staticRenderFns } from "./WhatsappPreview.vue?vue&type=template&id=7cd3291b&scoped=true&lang=pug&"
import script from "./WhatsappPreview.vue?vue&type=script&lang=js&"
export * from "./WhatsappPreview.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappPreview.vue?vue&type=style&index=0&id=7cd3291b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd3291b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VDivider,VIcon,VRow})
